.bar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--bg);
  padding: 18px 0 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 24px;
}

.search {
  flex: 1;
  max-width: 480px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 9px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.search:focus-within {
  border-color: var(--role-accent);
}

.searchInput {
  border: 0;
  outline: 0;
  background: transparent;
  flex: 1;
  font-family: var(--sans);
  font-size: 13.5px;
  color: var(--ink);
  min-width: 0;
}

.searchInput::placeholder {
  color: var(--mute-2);
}

.kbd {
  font-family: var(--mono);
  font-size: 10.5px;
  color: var(--mute);
  border: 1px solid var(--line);
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--surface-2);
  flex-shrink: 0;
}

.iconBtn {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 10px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-2);
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
}

.iconBtn:hover {
  background: var(--surface-2);
}

.indicator {
  position: absolute;
  top: 9px;
  right: 10px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: var(--orange);
}

.cta {
  background: var(--ink);
  color: #fff;
  border: 0;
  border-radius: 10px;
  padding: 9px 14px;
  font-size: 13.5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  flex-shrink: 0;
}

.cta:hover {
  opacity: .92;
}
